import { ReactComponent as HomeIcon } from "assets/icons/house-regular-full.svg";
import { ReactComponent as CollaboratorIcon } from "assets/icons/watch-regular-full.svg";
import { ReactComponent as TimesheetIcon } from "assets/icons/calendar-days-regular-full.svg";
import { ReactComponent as DirectorIcon } from "assets/icons/chart-sine-regular-full.svg";
import { ReactComponent as ManagerHourIcon } from "assets/icons/list-check-regular-full.svg";
import { ReactComponent as WorksessionRequestsIcon } from "assets/icons/user-list-duotone.svg";
import { ReactComponent as ManagerIcon } from "assets/icons/chart-mixed-solid-full.svg";
import { ReactComponent as UserIcon } from "assets/icons/users-gear-regular-full.svg";
import { ReactComponent as PermissionsIcon } from "assets/icons/shield-halved-solid-full.svg";
import { DomainCode, PermissionCode } from "features/auth/model/auth.types";
import { RequiredPermissionScope } from "shared/types/AppRoute";

export type SidebarItem = {
  name: string;
  iconName: keyof typeof iconsMap;
  domain?: DomainCode;
  requiredPermissions?: PermissionCode[];
  requiredPermissionsAny?: PermissionCode[];
  requiredPermissionScopesAny?: RequiredPermissionScope[];
  to?: string;
};

export const iconsMap = {
  Home: HomeIcon,
  "Dashboard Collaborator": CollaboratorIcon,
  Timesheet: TimesheetIcon,
  "Dashboard Director": DirectorIcon,
  "Hours Manager": ManagerHourIcon,
  "Operations Manager": ManagerIcon,
  "Worksession Requests": WorksessionRequestsIcon,
  Collaborators: UserIcon,
  Users: UserIcon,
  Permissions: PermissionsIcon,
} as const;
